import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIMultipartRequest, APIRequest, APIBlobRequest } from '../../common/Common';
import { TARGET_YEAR_API } from '../../common/data';

const initialState = {
  isRender: false,
  reload: -1,
  originList: [],

  categoryList: [],
  detailList: [],
};

// 증빙서류 메인리스트
export const getNopaperNew = createAsyncThunk('evidenceDocuments/getNopaperNew', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getNopaperNew`);
  return response;
});

// 증빙서류 상세
export const getNopaperDetail = createAsyncThunk(
  'evidenceDocuments/getNopaperDetail',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/getNopaperDetail`, data);
    return response;
  },
);

// 증빙서류 카테고리 함수
export const getNoPaperCategoryLoad = createAsyncThunk(
  'evidenceDocuments/getNoPaperCategoryLoad',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/getNoPaperCategoryLoad`, data);
    return response;
  },
);

//증빙서류 업로드
export const uploadEvidenceDocuments = createAsyncThunk(
  'evidenceDocuments/uploadEvidenceDocuments',
  async data => {
    const response = await APIMultipartRequest('/YA/NoPaperFileUploadEnd', data);
    return response;
  },
);

//증빙서류 삭제
export const deleteEvidenceDocuments = createAsyncThunk(
  'evidenceDocuments/deleteEvidenceDocuments',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/deleteNoPaperFile`, data);
    return response;
  },
);

//증빙서류 다운로드 (blob)
export const downloadEvidenceDocument = createAsyncThunk(
  'evidenceDocuments/downloadEvidenceDocument',
  async ({ htmFileSeq, htmFileType }) => {
    const response = await APIBlobRequest('/YA/download', {
      htmFileSeq,
      htmFileType,
    });
    return response;
  },
);

const evidenceDocumentsSlice = createSlice({
  name: 'evidenceDocuments',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },
    resetEvidenceDocumentsState: () => initialState, // 상태 리셋 액션 추가
  },
  extraReducers: builder => {
    builder.addCase(getNopaperNew.fulfilled, (state, action) => {
      //증빙서류 메인리스트
      console.log('증빙서류 메인리스트', action.payload);
      const { list } = action.payload;
      state.originList = list || [];
      state.isRender = true;
    });
    builder.addCase(getNoPaperCategoryLoad.fulfilled, (state, action) => {
      //증빙서류 카테고리 함수
      console.log('증빙서류 카테고리 함수', action.payload);
      state.categoryList = action.payload || [];
    });
    builder.addCase(uploadEvidenceDocuments.fulfilled, (state, action) => {
      //증빙서류 업로드
      console.log('증빙서류 업로드', action.payload);
      const { htmEditDate, deType, resultCode } = action.payload;
      if (resultCode === 'ERR') {
      }

      state.reload = Math.random();
    });
    builder.addCase(deleteEvidenceDocuments.fulfilled, (state, action) => {
      //증빙서류 삭제
      console.log('증빙서류 삭제', action.payload);

      state.reload = Math.random();
    });
    builder.addCase(getNopaperDetail.fulfilled, (state, action) => {
      //증빙서류 상세
      console.log('증빙서류 상세', action.payload);
      const { list } = action.payload;
      state.detailList = list || [];
    });
  },
});

export const { confirmDelete, resetEvidenceDocumentsState } = evidenceDocumentsSlice.actions;
export default evidenceDocumentsSlice.reducer;
